import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@api/api.service';
import { StripePlanRequestPlan } from '@api/types';
import { MessageService } from '@shared/message/message.service';
import { ModalService } from '@shared/modal/modal.service';
import { StripeElements } from '@stripe/stripe-js';
import { StripeService } from 'ngx-stripe';
import { Subscription } from 'rxjs';
import { AccountService } from '../../account.service';

@Component({
  selector: 'rav-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements AfterViewInit, OnDestroy {
  @ViewChild('cardInfo', { static: true }) cardInfo: ElementRef;
  elements: StripeElements;
  card: any;
  error = '';
  selectedPlan: StripePlanRequestPlan;
  isSubmitting = false;
  stripeTest: FormGroup;
  modalSubscription: Subscription;
  stripeSubscription: Subscription;

  constructor(
    private stripe: StripeService,
    private modal: ModalService,
    private api: ApiService,
    private account: AccountService,
    private message: MessageService
  ) {}

  ngAfterViewInit() {
    this.modal.close.subscribe(() => (this.error = null));

    this.modalSubscription = this.modal.open.subscribe((modalData) => {
      if (modalData.modalId !== 'payment') return;
      this.selectedPlan = modalData.selectedPlan || null;

      this.stripeSubscription = this.stripe.elements().subscribe((elements) => {
        this.elements = elements;
        if (this.card) return;
        this.card = this.elements.create('card', {
          style: {
            base: {
              iconColor: '#8299b1',
              color: '#0e1a23',
              lineHeight: '40px',
              fontFamily: '"Roboto", sans-serif',
              fontWeight: 300,
              fontSize: '18px',
              '::placeholder': {
                color: '#cccccc'
              }
            }
          }
        });
        this.card.mount(this.cardInfo.nativeElement);
        this.card.on('change', (changeData: any) => {
          this.error = changeData.error ? changeData.error.message : '';
        });
      });
    });
  }

  ngOnDestroy() {
    if (this.modalSubscription) this.modalSubscription.unsubscribe();
    if (this.stripeSubscription) this.stripeSubscription.unsubscribe();
  }

  async onSubmit() {
    const cardMessageVerb = this.account.details.card_last_four ? 'changed' : 'added';
    this.isSubmitting = true;
    const { token, error } = await this.stripe.createToken(this.card, {}).toPromise();
    if (error) return (this.error = error.message);
    try {
      await this.api.accounts.cards.post({ token: token.id }).toPromise();
      if (this.selectedPlan) {
        await this.api.accounts.plans.post({ plan: this.selectedPlan }).toPromise();
        this.message.show('billing-plan', {
          message: `Your plan was changed and your card was ${cardMessageVerb} successfully`,
          type: 'success'
        });
      } else {
        this.message.show('billing-card', {
          message: `Your card was ${cardMessageVerb} successfully`,
          type: 'success'
        });
      }
    } catch (e) {
      return (this.error = e.error
        ? e.error.message || e.message
        : 'An unknown error occurred, please try again or contact support');
    }
    this.modal.close.next({ reload: true });
    this.isSubmitting = false;
  }
}
